/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { getItemRequest, getItemsSuccess, getItemsFailed } from '../actions';
import { TIngredientType } from '../../utils/types';

export type TFetchInitialState = {
    isLoading: boolean;
    hasError: boolean;
    data: Array<TIngredientType>;
    error: null | string;
};

const initialState: TFetchInitialState = {
    isLoading: false,
    hasError: false,
    data: [],
    error: null,
};

export const fetchReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(getItemRequest, (state) => {
            state.isLoading = true;
        })
        .addCase(getItemsSuccess, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        })
        .addCase(getItemsFailed, (state, action) => {
            state.isLoading = false;
            state.hasError = true;
            state.data = [];
            state.error = action.payload;
        });
});

export default fetchReducer;
